module.exports = __webpack_public_path__ + "static/media/lancasteruni.2fed46b4.png";